import React from 'react';

const Refund: React.FC = () => {
  return (
    <div className="policy">
      <h1>Refunds & Cancellation Policy</h1>
      <p>
        Some features of ViewEventNotes are only available through a paid
        subscription.
      </p>

      <section>
        <h2>Subscription Fees</h2>
        <p>
          You agree to pay all applicable fees for your subscription based on
          the plan and billing cycle you select (e.g., monthly or annually). All
          fees are in GBP unless stated otherwise and may include VAT. Our VAT
          number is <strong>GB357 0399 78</strong>.
        </p>
      </section>

      <section>
        <h2>Cancellation</h2>
        <p>
          You can cancel your subscription at any time. Access to paid features
          will continue until the end of the current billing period.
        </p>
      </section>

      <section>
        <h2>Refunds</h2>
        <p>Refunds are only provided where required by law.</p>
      </section>

      <section>
        <h2>Renewals & Changes</h2>
        <p>
          Subscriptions automatically renew at the end of each billing period
          unless you cancel before the renewal date. We may change pricing or
          features at any time and will provide at least 14 days&apos; advance
          notice for changes affecting your plan. Continued use after the change
          constitutes acceptance of the new pricing.
        </p>
      </section>

      <section>
        <h2>Payment Issues</h2>
        <p>
          If a payment fails or a charge is disputed, we may suspend or
          downgrade your account until the issue is resolved.
        </p>
      </section>
    </div>
  );
};

export default Refund;
